import TabLogs from './TabLogs';

export default TabLogs;
